/* eslint-disable no-console */

import { useContext, useEffect } from 'react';

import axios from 'axios';
import ErrorState from 'components/layout/error-state/error-state';
import LoadingOlist from 'components/layout/loading-olist';
import { sendGTMEvent } from 'helpers/google-tag-manager';
import LeadsHeader from 'pages/leads/components/leads-header/leads-header';
import { useTranslation } from 'react-i18next';
import { useAsync } from 'react-use';
import { URL_LEAD_INFO } from 'utils/api-urls';

import { Container } from '@olist/templates';
import { Flex, Text } from '@olist/united';

import { RootContext } from '../../components/leads-provider';
import RequisitesForm from '../../components/requisites-form/requisites-form';
import { API_URLS } from '../../constants';

const RequisitesPage = () => {
  const { t } = useTranslation();

  const { leadIdCookie, leadProfileCookie, sessionIdCookie, setSessionIdCookie } =
    useContext(RootContext);
  const {
    error: requisitesError,
    loading: isLoadingRequisites,
    value: requisitesResponse,
  } = useAsync(async () => {
    const { data } = await axios.get(API_URLS.getRequisites({ leadId: leadIdCookie }));
    return data;
  }, [leadIdCookie]);

  const { value: leadsResponse } = useAsync(async () => {
    const { data } = await axios.get(URL_LEAD_INFO(leadIdCookie));
    return data;
  }, [leadIdCookie]);

  useEffect(() => {
    sendGTMEvent('page_view', {
      user_id: leadProfileCookie?.email,
    });
  }, [leadProfileCookie]);

  useEffect(() => {
    console.log(sessionIdCookie);
    if (sessionIdCookie) {
      setSessionIdCookie('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (requisitesError) {
    return (
      <Flex height="100vh" justifyContent="center" alignItems="center">
        <ErrorState onClick={() => window.location.reload()} />
      </Flex>
    );
  }

  if (isLoadingRequisites || !requisitesResponse) {
    return <LoadingOlist data-testid="qualification-loading-olist" />;
  }

  return (
    <Container>
      <LeadsHeader currentStep={LeadsHeader.steps.REQUIREMENTS} />
      <Flex justifyContent="flex-start" width={1} mt={4} mb={6} px={1}>
        <Flex flexDirection="column" justifyContent="center" maxWidth="485px">
          <Text fontSize={['23px', '26px']} fontWeight="bold" mb={4}>
            {t`before you start, do you meet the requirements to sell on olist?`}
          </Text>
          <RequisitesForm leadInfo={leadsResponse} initialRequisitesValues={requisitesResponse} />
        </Flex>
      </Flex>
    </Container>
  );
};

export default RequisitesPage;
